import { render, staticRenderFns } from "./orderComment.vue?vue&type=template&id=53a14bb6&"
import script from "./orderComment.vue?vue&type=script&lang=js&"
export * from "./orderComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports